/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Schedule_EmptyInputs */

const th_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีการแข่งขัน`)
};

const en_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No games scheduled yet.`)
};

const ja_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定されている試合はまだありません。`)
};

const zh_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比赛。`)
};

const es_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay partidos programados.`)
};

const pt_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo agendado ainda.`)
};

const id_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pertandingan yang dijadwalkan.`)
};

const fr_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun match programmé pour l’instant.`)
};

const tl_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang nakaiskedyul na laro.`)
};

const vi_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xếp trận nào.`)
};

const ko_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 편성된 경기가 없습니다.`)
};

const de_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Spiele angesetzt.`)
};

const ru_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчи ещё не назначены.`)
};

const tr_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz maç planlanmadı.`)
};

const it_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna partita ancora in calendario.`)
};

const pl_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zaplanowano jeszcze meczów.`)
};

const uk_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчів ще не заплановано.`)
};

const hi_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई मैच निर्धारित नहीं है।`)
};

const ar_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُجدوَل أي مباراة بعد.`)
};

const ms_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada perlawanan dijadualkan.`)
};

const bn_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও খেলা নির্ধারিত হয়নি।`)
};

const zh_tw2_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比賽。`)
};

const zh_hk2_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比賽。`)
};

const ur_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی میچ طے نہیں ہوا۔`)
};

const fa_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز بازی‌ای برنامه‌ریزی نشده.`)
};

const sw_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mchezo uliopangwa bado.`)
};

const nl_schedule_empty = /** @type {(inputs: Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen wedstrijden ingepland.`)
};

/**
* | output |
* | --- |
* | "No games scheduled yet." |
*
* @param {Schedule_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const schedule_empty = /** @type {((inputs?: Schedule_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Schedule_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_schedule_empty(inputs)
	if (locale === "ja") return ja_schedule_empty(inputs)
	if (locale === "zh") return zh_schedule_empty(inputs)
	if (locale === "es") return es_schedule_empty(inputs)
	if (locale === "pt") return pt_schedule_empty(inputs)
	if (locale === "id") return id_schedule_empty(inputs)
	if (locale === "fr") return fr_schedule_empty(inputs)
	if (locale === "tl") return tl_schedule_empty(inputs)
	if (locale === "vi") return vi_schedule_empty(inputs)
	if (locale === "ko") return ko_schedule_empty(inputs)
	if (locale === "de") return de_schedule_empty(inputs)
	if (locale === "ru") return ru_schedule_empty(inputs)
	if (locale === "tr") return tr_schedule_empty(inputs)
	if (locale === "it") return it_schedule_empty(inputs)
	if (locale === "pl") return pl_schedule_empty(inputs)
	if (locale === "uk") return uk_schedule_empty(inputs)
	if (locale === "hi") return hi_schedule_empty(inputs)
	if (locale === "ar") return ar_schedule_empty(inputs)
	if (locale === "ms") return ms_schedule_empty(inputs)
	if (locale === "bn") return bn_schedule_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_schedule_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_schedule_empty(inputs)
	if (locale === "ur") return ur_schedule_empty(inputs)
	if (locale === "fa") return fa_schedule_empty(inputs)
	if (locale === "sw") return sw_schedule_empty(inputs)
	if (locale === "nl") return nl_schedule_empty(inputs)
	return en_schedule_empty(inputs)
});